import React from 'react'
import { Button } from '../../lib'
import { billingStore } from '../../app/stores'

const cancelSubscription = () => {
  if (window.confirm('Are you sure you want to cancel your subscription?')) {
    billingStore.cancelSubscription()
  }
}

const CancelPlan = () => {
  return (
    <p>
      Do you want to&nbsp;
      <Button styleType='text' onClick={cancelSubscription}>
        cancel your subscription plan
      </Button>?
    </p>
  )
}

export default CancelPlan



// WEBPACK FOOTER //
// ./src/account/billing/CancelPlan.js